import { MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType } from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import { openapi_website_cms_getHeadlineCarouselActive, decodeResponse200, Response200Type } from 'src/api_openapi/generated/openapi_website_cms_getHeadlineCarouselActive';

export type HeadlineCarouselActiveModelType = Response200Type extends Array<infer Model> ? Model : never;

const decode = (status: number, data: ResponseType): Array<HeadlineCarouselActiveModelType> => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }
    if (status === 404 || status === 500) {
        return [];
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

interface HeadlineCarouselActiveParams {
    collectionSlug: string
}

export const getHeadlineCarouselActive = {
    browser: {
        params: (params: HeadlineCarouselActiveParams): ParamsFetchType<HeadlineCarouselActiveParams> => {
            return {
                type: MethodType.POST,
                url: '/api-web/get-headline-carousel-active',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/get-headline-carousel-active',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<HeadlineCarouselActiveParams>): Promise<GenerateUrlApiType> => {
        const response = await openapi_website_cms_getHeadlineCarouselActive(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
        // const response = await openapi_website_cms_getHeadlineCarouselActive('http://localhost:3005', params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            collection_slug: params.req.body.collectionSlug
        });

        return {
            passToBackend: false,
            status: response.status,
            responseBody: response.body
        };
    }
};
